module.exports = __webpack_public_path__ + "img/Pharmacists and the Elderly in Malaysia.23089065.jpg";